import "./LostFound.css";

function LostFound(): JSX.Element {
    return (
        <div className="LostFound">
			Lost and found
        </div>
    );
}

export default LostFound;
